export const dateConfig = {
  format: {
    date: 'MM/DD/YYYY',
    dateTime: 'MM/DD/YYYY HH:mm',
    shortDate: 'MM/DD',
  },
};
